module.exports = __webpack_public_path__ + "img/the-netherlands-skin-connective-and-musculoskeletal-diseases-female.3bcf7228.png";